/**
 * Lab Analyte Service
 * Autocomplete suggestions for the form builder's Expected Lab Results input.
 */

import axiosInstance from '../axiosInstance';

/**
 * @typedef {Object} LabAnalyteSuggestion
 * @property {string} name
 * @property {string|null} units
 * @property {number} usageCount
 */

const labAnalyteService = {
  /**
   * Fetch analyte-name suggestions scoped to the caller's organization.
   * @param {string} query
   * @param {number} limit
   * @param {AbortSignal} [signal]
   * @returns {Promise<LabAnalyteSuggestion[]>}
   */
  getSuggestions: async (query = '', limit = 20, signal) => {
    const params = {};
    if (query) params.q = query;
    if (limit) params.limit = limit;
    const response = await axiosInstance.get('/api/lab-analytes/suggestions', { params, signal });
    return response.data || [];
  },
};

export default labAnalyteService;
